import { enterpriseApiSlice } from "./index";
import { CreditCardInfo } from "../Model/paymentObjects";

export const cardApi = enterpriseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchCards: builder.query({
      query: () => ({
        url: "/stripe/cards",
        method: "GET",
      }),
      extraOptions: { auth: true },
      providesTags: ["Cards"],
      transformResponse: (response) => new CreditCardInfo(response),
    }),
    addCard: builder.mutation({
      query: (body) => ({
        url: "/stripe/cards",
        method: "POST",
        body,
      }),
      extraOptions: { auth: true },
      invalidatesTags: ["Cards"],
    }),
    deleteCard: builder.mutation({
      query: (cardId) => ({
        url: `/stripe/cards/${cardId}`,
        method: "DELETE",
      }),
      extraOptions: { auth: true },
      invalidatesTags: ["Cards"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetchCardsQuery,
  useAddCardMutation,
  useDeleteCardMutation,
} = cardApi;

